import { render } from "./Edit.vue?vue&type=template&id=578bf1ef"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
script.render = render

export default script